/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_Terms_Privacy_Terms_LinkInputs */

const en_consent_terms_privacy_terms_link = /** @type {(inputs: Consent_Terms_Privacy_Terms_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms of Service`)
};

const de_consent_terms_privacy_terms_link = /** @type {(inputs: Consent_Terms_Privacy_Terms_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AGB`)
};

const fr_consent_terms_privacy_terms_link = /** @type {(inputs: Consent_Terms_Privacy_Terms_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conditions Generales`)
};

const es_consent_terms_privacy_terms_link = /** @type {(inputs: Consent_Terms_Privacy_Terms_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminos de Servicio`)
};

const it_consent_terms_privacy_terms_link = /** @type {(inputs: Consent_Terms_Privacy_Terms_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termini di Servizio`)
};

const nl_consent_terms_privacy_terms_link = /** @type {(inputs: Consent_Terms_Privacy_Terms_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algemene Voorwaarden`)
};

const pl_consent_terms_privacy_terms_link = /** @type {(inputs: Consent_Terms_Privacy_Terms_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regulamin`)
};

const fi_consent_terms_privacy_terms_link = /** @type {(inputs: Consent_Terms_Privacy_Terms_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kayttoehdot`)
};

const da_consent_terms_privacy_terms_link = /** @type {(inputs: Consent_Terms_Privacy_Terms_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handelsbetingelserne`)
};

const sv_consent_terms_privacy_terms_link = /** @type {(inputs: Consent_Terms_Privacy_Terms_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anvandarvillkoren`)
};

/**
* | output |
* | --- |
* | "Terms of Service" |
*
* @param {Consent_Terms_Privacy_Terms_LinkInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consent_terms_privacy_terms_link = /** @type {((inputs?: Consent_Terms_Privacy_Terms_LinkInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_Terms_Privacy_Terms_LinkInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consent_terms_privacy_terms_link(inputs)
	if (locale === "fr") return fr_consent_terms_privacy_terms_link(inputs)
	if (locale === "es") return es_consent_terms_privacy_terms_link(inputs)
	if (locale === "it") return it_consent_terms_privacy_terms_link(inputs)
	if (locale === "nl") return nl_consent_terms_privacy_terms_link(inputs)
	if (locale === "pl") return pl_consent_terms_privacy_terms_link(inputs)
	if (locale === "fi") return fi_consent_terms_privacy_terms_link(inputs)
	if (locale === "da") return da_consent_terms_privacy_terms_link(inputs)
	if (locale === "sv") return sv_consent_terms_privacy_terms_link(inputs)
	return en_consent_terms_privacy_terms_link(inputs)
});